import i18n from '@/i18n';

export function groupByProperty(array: Array<any>, callback: (item: any) => void) {
   const groups: any = {};
   array.forEach(function (item) {
      const group = JSON.stringify(callback(item));
      groups[group] = groups[group] || [];
      groups[group].push(item);
   });
   return Object.keys(groups).map((group) => groups[group]);
}

export function groupByMultipleProperties(data: Array<any>, keys: Array<string>, transform = (v: any) => v, value?: string) {
   return data.reduce((acc, d) => {
      const group = keys.reduce((current, key) => {
         let next = current.find((c: any) => c[key] === d[key]);

         if (!next) {
            next = {
               [key]: d[key],
               value: value ? d[value] : null,
               items: [],
            };

            current.push(next);
         }
         return next.items;
      }, acc);
      group.push(transform ? transform(d) : d);
      return acc;
   }, []);
}

export function uniqueArray(array: Array<any>, key: string) {
   return array.reduce((acc, current) => {
      const x = acc.find((item: any) => item[key] === current[key]);
      if (!x) {
         return acc.concat([current]);
      } else {
         return acc;
      }
   }, []);
}

export function stringifyArray(array: Array<string>) {
   return array.reduce((acc, cur, index) => {
      if (index === 0) return cur;
      if (index === array.length - 1) return `${acc} ${i18n.global.t('generic.and')} ${cur}`;
      return `${acc}, ${cur}`;
   }, '');
}

export function flattenArray(array: Array<any>, depth = 1) {
   return array.flat(depth);
}

export function containsAll(array1: Array<any>, array2: Array<any>) {
   return array1.every((i) => array2.includes(i));
}
